import dashboard from 'customer/Dashboard/reducer'

export default {
  dashboard,
}
